import React from 'react';

const Composer = ({ components, children }) => components
  .reduce((acumulator, Component) => <Component>{acumulator}</Component>, <>{children}</>);

export default Composer;
